export const PROPERTY_TYPE_OPTIONS = [
  'apartment',
  'garsoniere',
  'villa',
  'office',
  'magazine',
  'shop',
  'parkim',
  'land',
];
